import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { UseFormReturn } from "react-hook-form";
import type { AdminFormValues } from "@/types/admin";

interface WorkExperienceProps {
  form: UseFormReturn<AdminFormValues>;
}

export const WorkExperience = ({ form }: WorkExperienceProps) => {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="occupation"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Vad har du för yrke?</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="workplace"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Vilken är din arbetsplats där du håller "Föräldraskap i Sverige"?</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="previous_group_experience"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Har du lett någon grupp tidigare?</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={(value) => field.onChange(value === "true")}
                value={field.value.toString()}
                className="flex space-x-4"
              >
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="true" id="ja" />
                  <label htmlFor="ja">Ja</label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="false" id="nej" />
                  <label htmlFor="nej">Nej</label>
                </div>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {form.watch("previous_group_experience") && (
        <FormField
          control={form.control}
          name="previous_groups"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Om ja, ange vilken/vilka slags grupper</FormLabel>
              <FormControl>
                <Input {...field} value={field.value || ''} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      <FormField
        control={form.control}
        name="fos_groups_count"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Antal genomförda FÖS-grupper?</FormLabel>
            <FormControl>
              <Input 
                type="number" 
                {...field}
                onChange={(e) => field.onChange(parseInt(e.target.value))}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};